export default __webpack_public_path__ + "static/media/hero-img.3edd7c8c.svg";